import CvCheckbox from './CvCheckbox.vue';
import CvCheckboxSkeleton from './CvCheckboxSkeleton.vue';
export { CvCheckbox, CvCheckboxSkeleton };
export default CvCheckbox;
